// ink-component
import React, { ReactNode, HTMLAttributes } from 'react';
import styled from 'styled-components';

import getGlobalProps from '../../helpers/constants/global-props';

export interface UlProps extends HTMLAttributes<HTMLUListElement> {
  /** Content */
  children: ReactNode;
}

/* internal */
export const StyledList = styled.ul`
  list-style: disc outside none;
  padding-left: 16px;

  & & {
    list-style-type: circle;
  }

  & & & {
    list-style-type: square;
  }
`;

const globalProps = getGlobalProps({});

/**
 * @purpose List unordered text elements as bullet points
 * @group SimpleList
 * @categories layout
 * @aka unordered list
 */
export function Ul(props: UlProps) {
  const { style, className, ...otherProps } = props;

  /* Safari/webkit requires explicit role tag */
  /* https://developer.mozilla.org/en-US/docs/Web/CSS/list-style#accessibility_concerns */

  return <StyledList {...otherProps} {...globalProps} role="list" />;
}

Ul.defaultProps = {
  children: undefined,
};

Ul.displayName = 'Ul';

export default Ul;
